export function ErrorBannerText({ error }: { error: any }) {
  const status = error.status || error.data?.status;
  if (status === 403) {
    return <>Your session has expired. Please login again</>;
  }
  if (status === 401) {
    return <>(You are not authorized)</>;
  }
  const message = typeof error === "string" ? error : null;
  return (
    <>
      {message ||
        `An unknown error occurred, please try again ${
          status ? `(${status})` : ""
        }`}
    </>
  );
}
